<div class="heading">
  <h3>{{heading}}</h3>
  <p class="description">{{description}}</p>
  <ion-button class="text-margin" ion-fab tappable (click)="buttonClicked()" full>{{buttonText}}</ion-button> 
</div>

<div class="no-listing-cont" style="margin-bottom: 10px">
  <ion-skeleton-text height="50px" width="50px" rounded></ion-skeleton-text>
  <div style="width: calc(100% - 65px);">
    <ion-skeleton-text style="width: calc(100%);" class="animated-background no-listing" rounded></ion-skeleton-text>
    <ion-skeleton-text style="width: calc(80%);" class="animated-background no-listing" rounded></ion-skeleton-text>
  </div>
</div>
<div class="no-listing-cont" style="margin-bottom: 10px">
  <ion-skeleton-text height="50px" width="50px" rounded></ion-skeleton-text>
  <div style="width: calc(100% - 65px);">
    <ion-skeleton-text style="width: calc(80%);" class="animated-background no-listing" rounded></ion-skeleton-text>
    <ion-skeleton-text style="width: calc(90%);" class="animated-background no-listing" rounded></ion-skeleton-text>
  </div>
</div>
<div class="no-listing-cont">
  <ion-skeleton-text height="50px" width="50px" rounded></ion-skeleton-text>
  <div style="width: calc(100% - 65px);">
    <ion-skeleton-text style="width: calc(100%);" class="animated-background no-listing" rounded></ion-skeleton-text>
    <ion-skeleton-text style="width: calc(50%);" class="animated-background no-listing" rounded></ion-skeleton-text>
  </div>
</div>